import React from "react";
import "./Trending_product_card.css";
import Explore_btn from "../../common-buttons/explore-button/Explore_btn";
import { postWishlist } from "../../../../features/wishlist/wishlistSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../../utils/common";

const Trending_product_card = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const is_signin = useSelector((state) => state.auth.is_signin);

  const addToWish = async () => {
    if (!is_signin) {
 
      await navigate("/login");
    } else {
      const res = await dispatch(postWishlist({ product_id: props?.id }));
      if (res.meta?.requestStatus === "fulfilled") {
        setTimeout(() => {
          navigate("/wishlist");
        }, 500);
      } else if (res.meta?.requestStatus === "rejected") {
      }
    }
  };
  return (
    <>
      <div className="Trending_product_card">
        <div
          className="imgdiv"
          onClick={() => navigate(`/product-descrption/${encodeId(props?.id)}`)}
        >
          <img
            className="product_img"
            src={process.env.REACT_APP_IMAGE_URL + props?.image}
            alt="product-image"
          />
        </div>

        <div className="content">
          <h6 className="prod-name">{props.name}</h6>
          <p className="modno">{props.prono}</p>
          {/* <button className='buynowbtn'>Buy Now</button> */}
          <Explore_btn
            name={"Add To Wishlist"}
            onClick={() => {
              addToWish();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Trending_product_card;
